import React from 'react';
import { ClockSwitch } from '@app/components/common/ClockSwitch/ClockSwitch';
import { ClockType } from '@app/interfaces/interfaces';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { setClock } from '@app/store/slices/ClockModeSlice';

export const ClockPicker: React.FC = () => {
  const dispatch = useAppDispatch();
  const clock = useAppSelector((state) => state.clock.clock);

  const handleClickButton = (clock: ClockType) => {
    dispatch(setClock(clock));
  };

  return (
    <ClockSwitch
      isClockActive={clock === 'analog'}
      onClickAnalog={() => handleClickButton('analog')}
      onClickDigital={() => handleClickButton('digital')}
    />
  );
};
